/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Home_Footer_CopyrightInputs */

const en_home_footer_copyright = /** @type {(inputs: Home_Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.companyName}. All rights reserved.`)
};

const fr_home_footer_copyright = /** @type {(inputs: Home_Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.companyName}. Tous droits réservés.`)
};

/**
* | output |
* | --- |
* | "{companyName}. All rights reserved." |
*
* @param {Home_Footer_CopyrightInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_footer_copyright = /** @type {((inputs: Home_Footer_CopyrightInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Footer_CopyrightInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_footer_copyright(inputs)
	return fr_home_footer_copyright(inputs)
});